/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnalyticSearch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M17 13c2.2 0 4 1.8 4 4 0 .7-.2 1.4-.6 2l2.3 2.3-1.4 1.4-2.3-2.3c-.6.4-1.3.6-2 .6-2.2 0-4-1.8-4-4s1.8-4 4-4zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
        <path d="M4 2v8.6l6-6 4 4L18.6 4H15V2h7v7h-2V5.4l-6 6-4-4-6 6V20h8v2H2V2z" />
      </g>
    </g>
  </Icon>
);
export { SvgAnalyticSearch as AnalyticSearch };
